// Footer accordion
document.addEventListener('DOMContentLoaded', (event) => {
  const footerBlocks = document.querySelectorAll(".footer-blocks > div");
  
  if (footerBlocks) {
    footerBlocks.forEach(block => {
        const header = block.querySelector("summary");
        // console.log("block", header);

        header.addEventListener("click", function(event) {
            // console.log("click", this);
            this.dataset.open = this.dataset.open === "false"; 
        });
    });
  }

  // Fancybox arrow, flickity arrow button on product page
  if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType === 'product') {
    const flickityInterval = setInterval(changeFlickityIcon, 100);

    function changeFlickityIcon() {
      const flickityButtons = document.querySelectorAll(".flickity-button");
      // console.log("flickityButtons", flickityButtons);
      if (flickityButtons.length > 0) {
        flickityButtons.forEach(button => {
          if (button.getAttribute('aria-label') == "Previous") {
            button.innerHTML = `<svg class="flickity-button-icon" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_1_6)">
                                  <path d="M8.1001 15.1L1.1001 8.09998L8.1001 1.1" stroke="#333333" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  </g>
                                  <defs>
                                  <clipPath id="clip0_1_6">
                                  <rect width="9" height="16" fill="white" transform="translate(9 16) rotate(-180)"/>
                                  </clipPath>
                                  </defs>
                                  </svg>`;
          } else if (button.getAttribute('aria-label') == "Next") {
            button.innerHTML = `<svg class="flickity-button-icon" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1_3)">
                                <path d="M0.899902 0.900024L7.8999 7.90002L0.899905 14.9" stroke="#333333" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1_3">
                                <rect width="9" height="16" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>`;
          }
        });
        clearInterval(flickityInterval);
      }
    }
  }
  
})

// ======MLVeda Currency Switcher======
const currencyInterval = setInterval(appendCurrencyToHeader, 1000);
function appendCurrencyToHeader() {
  const currency = document.querySelector(".pick_currency");
  const ulMenu = document.querySelector(
    "ul.header__secondary-navigation.menu.right"
  );
  const newLi = document.createElement("li");
  if (currency != null) {
    if (window.screen.width >= 769) {
      newLi.appendChild(currency);
      ulMenu.insertBefore(newLi, ulMenu.firstChild);
      clearInterval(currencyInterval);
    } else {
      const mobileHeader = document.querySelector("#header")
      mobileHeader.appendChild(currency)
      clearInterval(currencyInterval);
    }
  }
}

// Show Accordion Content
function showContent(el) {
  const sibling = el.nextElementSibling
  const chevDown = el.lastElementChild.previousElementSibling
  const chevUp = el.lastElementChild
  sibling.classList.toggle("link-open")
  chevDown.classList.toggle("hidden")
  chevUp.classList.toggle("hidden")
}

// ======Hulkapps Wishlist======
// if (typeof window.hulkappsWishlist === 'undefined') {
//   window.hulkappsWishlist = {};
// }
// window.hulkappsWishlist.baseURL = '/apps/advanced-wishlist/api';
// window.hulkappsWishlist.hasAppBlockSupport = '';

// Article blog
if (window.ShopifyAnalytics.meta.page.pageType == "blog") {
  document.addEventListener('DOMContentLoaded', (event) => {
    const prev = document.querySelector(".prev a");
    const next = document.querySelector(".next a");
    if (prev) prev.innerHTML = "<";
    if (next) next.innerHTML = ">";
  });
}